import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { useAppSelector } from "app/redux/hooks";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { adicionarItens } from "app/use-cases/orcamento/adicionarItens";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { ItensOrcamentoContainer } from "../itens-orcamento/ItensOrcamentoContainer";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { Agregados, EntitesProdutoAgregado } from "./Agregados";
import { Parametro } from "app/types/Parametro";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto";

export type AgregadosContainerProps = {
    item: IItemOrcamento,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string, () => void>,
    foraOrcamento: boolean
}

export const AgregadosContainer = (props: AgregadosContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
    const [agregados, setAgregados] = useState<PagedMessageResponse<EntitesProdutoAgregado>>()
    const [parametros, setParametros] = useState<Parametro[]>([])

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)

    const onObterDadosProdutosAgregados = async (numeroPagina?: number) => {
        try {
            globalMU.blockUI(); 
            const resposta = await microuniversoApi.Produto.consultarAgregados({
                Codigo: props.item.Codigo,
                AreaVenda: orcamento.AreaVenda,
                NumeroPagina: numeroPagina ?? 1,
                TamanhoPagina: 20,
            });
            ("HasErrors" in resposta || resposta?.Entities?.length == 0) ? (setAgregados({}), onVoltar()) : setAgregados(resposta);
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onVoltarGridItens = () => {
        renderizarComponentReact(
            < ItensOrcamentoContainer />,
            "conteudo-pagina",
            true
        )
    }

    const onAdicionarProdutosAgregados = async (itensSelecionados: EntitesProdutoAgregado[]) => {
        try {

            if (itensSelecionados.length == 0) {
                globalMU.showErrorMessage("Por favor, selecione os produtos a serem adicionados.");
                return;
            }

            await adicionarItens(orcamento.IdentificadorOrcamento, itensSelecionados)
            onVoltarGridItens()

        } catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    // const atualizarParametros = async () => {
    //     setParametros(
    //       await obterParametros({
    //         nomes: [
    //           "CHAVE_MOVIMENTACAO_ORCAMENTO"
    //         ]
    //       })
    //     )
    //   }
    
    // const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    useEffect(() => {
        passosInterno.current.set("Agregados", () => { renderizarComponentReact(<AgregadosContainer {...props} />, "conteudo-pagina", true) })
        onObterDadosProdutosAgregados()
        //atualizarParametros()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
                id="AgregadosBreadcrumb"
            />
            <Agregados
                //codigo={valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? props.item.Codigo : props.item.Referencia}
                codigo={ props.item.CodigoProdutoExibicao && props.item.CodigoProdutoExibicao.trimEnd() != ""  ? props.item.CodigoProdutoExibicao.trimEnd() : props.item.CodigoProduto.trimEnd() }
                descricao={props.item.Descricao}
                dadosAgregados={agregados}
                corSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                onPesquisarPaginado={onObterDadosProdutosAgregados}
                onOk={onAdicionarProdutosAgregados}
                foraOrcamento={props.foraOrcamento}
            />
        </>

    )
}